// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const GoalSleep = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M13.9 61.292C19.443 74.563 32.6 83.5 47.292 83.5c19.96 0 36.197-16.167 36.197-36.038 0-15.233-9.469-28.534-23.509-33.726A35.931 35.931 0 0 1 62.69 27.39c0 19.921-16.27 36.127-36.269 36.127-4.33 0-8.524-.746-12.52-2.224M47.292 87.5c-17.996 0-33.915-12.075-38.71-29.366a2 2 0 0 1 2.853-2.307 32.01 32.01 0 0 0 14.984 3.69c17.793 0 32.27-14.413 32.27-32.128 0-5.55-1.47-11.047-4.25-15.894a2 2 0 0 1 2.195-2.94C74.802 12.87 87.49 28.868 87.49 47.461 87.49 69.54 69.458 87.5 47.293 87.5M23.97 26.983a11.904 11.904 0 0 1 4.666 4.664 11.917 11.917 0 0 1 4.666-4.664 11.917 11.917 0 0 1-4.666-4.664 11.904 11.904 0 0 1-4.666 4.664m4.666 15.5a2 2 0 0 1-2-2c0-7.738-3.764-11.5-11.509-11.5a2 2 0 0 1 0-4c7.745 0 11.51-3.762 11.51-11.5a2 2 0 0 1 4 0c0 7.738 3.764 11.5 11.51 11.5a2 2 0 0 1 0 4c-7.746 0-11.51 3.762-11.51 11.5a2 2 0 0 1-2 2"
			fillRule="evenodd"
		/>
	</svg>
);
export default GoalSleep;
